import script from "./BookingCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./BookingCalendar.vue?vue&type=style&index=0&id=4d2bbe18&lang=scss"

const __exports__ = script;

export default __exports__